import React, { Component } from "react";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";
import * as Format from "../../common/FormatFunctions";
//Common Functions
import { LoadScreen } from "../Common/LoadScreen";
import * as Feedback from "../../common/Feedback/Feedback";
import { CrudlStatus } from "../../common/config/AppConstants";
import * as log from "../../common/Feedback/Log";

import { ChartViewModel } from "./ChartViewModel";

import { BPMStatistics } from "../Common/BPMChart";
import { DisplayType } from "../Common/Statistics/ChartObjects";
import { ChartType } from "../Common/Statistics/ChartObjects";

import * as ChartHelper from "./ChartExamples";

//import "./CustomCSS/charts.css";
export class ChartsV2 extends Component {
  constructor() {
    super();
    this.state = {
      // LOADING FLAGS
      loaded: false,
      editLoaded: true,

      //DIALOG FLAGS
      toggleChangesMade: false,
      toggleDeleted: false,

      //DISPLAY VIEW
      editView: false,

      // DETAILS
      chartList: [],
      originalEditedChart: "",
      editedChart: {},

      crudlState: CrudlStatus.LIST,

      // DATA TABLE
      expandedRows: null,
      tableColumns: [],
      colOptions: [],

      //SITE BUILDING LOCATION STATUS SELECTOR
      availableChartStatus: [],
      siteList: [],
      siteOptions: [],
      editedChartSelectedSite: "",
      buildingList: [],
      buildingOptions: [],
      editedChartSelectedBuilding: "",
      locationList: [],
      locationOptions: [],

      showPivotTable: false
    };

    //SET UP LOGGER AND VIEWMODEL
    this.logger = log;
    this.viewModel = new ChartViewModel(
      this.updateState,
      this.showError,
      this.showSuccess,
      this.showEmpty
    );
  }

  componentDidMount = () => {
    this.initialDataRender();
  };

  initialDataRender = async () => {
    await this.setPageData();
  };

  setPageData = async () => {
    this.setState({ loaded: false, editLoaded: false });

    this.setState({ loaded: true, editLoaded: true });
  };

  //View Model Link Functions

  showError = (display, crudlStatus) => {
    Feedback.showError(this.growl, display, crudlStatus);
  };
  showSuccess = (display, crudlStatus) => {
    Feedback.showSuccess(this.growl, display, crudlStatus);
  };
  showEmpty = display => {
    Feedback.showEmpty(this.growl, display);
  };
  updateState = (key, value) => {
    this.setState({ [key]: value });
  };

  // #region Cloud

  updateChart = async () => {
    this.setState({ editLoaded: false });

    var stateVariables = this.getStateValuesAsObject();
    var chartResponse = await this.viewModel.executeCRUDLAction(
      CrudlStatus.UPDATE,
      stateVariables
    );

    if (chartResponse.errorCode === 0) {
      this.setState({
        editView: false
      });
      this.updateChartList(chartResponse, CrudlStatus.UPDATE, stateVariables);
    } else {
      this.setState({ editLoaded: true });
    }
  };

  addChart = async () => {
    this.setState({ editLoaded: false });
    var stateVariables = this.getStateValuesAsObject();

    var chartResponse = await this.viewModel.executeCRUDLAction(
      CrudlStatus.CREATE,
      stateVariables
    );

    if (chartResponse.errorCode === 0) {
      this.setState({
        editView: false
      });
      this.updateChartList(chartResponse, CrudlStatus.CREATE, stateVariables);
    } else {
      this.setState({ editLoaded: true });
    }
  };

  deleteChart = async () => {
    this.setState({ loaded: false });

    var stateVariables = this.getStateValuesAsObject();

    var chartResponse = await this.viewModel.executeCRUDLAction(
      CrudlStatus.DELETE,
      stateVariables
    );

    if (chartResponse.errorCode === 0) {
      this.updateChartList(chartResponse, CrudlStatus.DELETE, stateVariables);
    } else {
      this.setState({ loaded: true });
    }
  };
  // #endregion

  // #region ViewFunctions

  updateChartList = (apiResponse, type, stateVariables) => {
    this.viewModel.reloadDataAfterExecute(
      this.state.chartList,
      apiResponse,
      type,
      stateVariables
    );

    this.setState({
      loaded: true,
      editLoaded: true,
      crudlState: CrudlStatus.LIST,
      originalEditedChart: JSON.stringify({}),
      editedChart: {}
    });
  };

  updateBean = async (field, value) => {
    await this.setState(prevState => ({
      editedChart: {
        // object that we want to update
        ...prevState.editedChart, // keep all other key-value pairs
        [field]: value
      }
    }));
    this.logger.info(value);
  };

  updateBeanExecute = async (field, value, functionToExecute) => {
    await this.setState(
      prevState => ({
        editedChart: {
          // object that we want to update
          ...prevState.editedChart, // keep all other key-value pairs
          [field]: value
        }
      }),
      () => {
        functionToExecute();
      }
    );
    this.logger.info(value);
  };

  validateChanges = () => {
    if (
      Format.isJsonEqual(this.state.originalEditedChart, this.state.editedChart)
    ) {
      this.discardChanges();
    } else {
      this.setState({ toggleChangesMade: true });
    }
  };

  discardChanges = () => {
    this.setState({
      editView: false,
      toggleChangesMade: false
    });
  };

  checkRequiredFields = () => {
    return Format.validateValues([
      this.state.editedChart.description,
      this.state.editedChart.name
    ]);
  };

  export = () => {
    this.dt.exportCSV();
  };

  createExecute = () => {
    window.scrollTo(0, 0);
    this.setState({
      editView: true,
      crudlState: CrudlStatus.CREATE,
      editedChart: {},
      originalEditedChart: JSON.stringify({})
    });
  };

  updateExecute = data => {
    window.scrollTo(0, 0);
    this.setState({
      editView: true,
      crudlState: CrudlStatus.UPDATE,
      editedChart: data,
      originalEditedChart: JSON.stringify(data)
    });
  };

  deleteExecute = data => {
    this.setState({
      crudlState: CrudlStatus.DELETE,
      editedChart: data,
      originalEditedChart: JSON.stringify(data),
      toggleDeleted: true
    });
  };

  runAction = () => {
    if (this.state.crudlState === CrudlStatus.CREATE) {
      this.addChart();
    }
    if (this.state.crudlState === CrudlStatus.UPDATE) {
      this.updateChart();
    }
    if (this.state.crudlState === CrudlStatus.DELETE) {
      this.deleteChart();
    }
  };

  // #endregion

  // #region View
  render() {
    const s = this.state;

    return (
      <div>
        <div
          className="ui-g dashboard"
          style={s.editLoaded === false ? { pointerEvents: "none" } : {}}
        >
          {s.loaded === false ? (
            <LoadScreen />
          ) : (
            <div className="ui-g-12">
              {/*Editing Card*/}
              {this.getChartView()}
            </div>
          )}
        </div>
      </div>
    );
  }
  getChartView = () => {
    return (
      <div>
        <div>
          <pr.TabView
            activeIndex={this.state.activeIndex}
            onTabChange={e => this.setState({ activeIndex: e.index })}
          >
            {this.getChart(
              DisplayType.CHART,
              ChartType.PIE,
              ChartHelper.renderPieData(),
              ChartHelper.renderPieOptions()
            )}
            {this.getChart(
              DisplayType.CHART,
              ChartType.BAR,
              ChartHelper.renderBarData(),
              ChartHelper.renderBarOptions()
            )}
            {this.getChart(
              DisplayType.CHART,
              ChartType.AREA,
              ChartHelper.renderAreaData(),
              ChartHelper.renderAreaOptions()
            )}
            {this.getChart(
              DisplayType.CHART,
              ChartType.GANTT,
              ChartHelper.renderGanttData(),
              ChartHelper.renderGanttOptions()
            )}
            {this.getChart(
              DisplayType.CHART,
              ChartType.COMBO,
              ChartHelper.renderComboData(),
              ChartHelper.renderComboOptions()
            )}
            {this.getChart(
              DisplayType.CHART,
              ChartType.GAUGE,
              ChartHelper.renderGuageData(),
              ChartHelper.renderGuageOptions()
            )}
            {this.getChart(
              DisplayType.CHART,
              ChartType.TIMELINE,
              ChartHelper.renderTimelineData(),
              ChartHelper.renderTimelineOptions()
            )}

            {this.getChartAndTable(
              DisplayType.CHART,
              ChartType.BAR,
              ChartHelper.renderProductLeadTimeData(),
              ChartHelper.renderProductLeadTimeOptions()
            )}
          </pr.TabView>
        </div>
      </div>
    );
  };

  getChartAndTable = (displayType, chartType, chartData, chartOptions) => {
    return (
      <pr.TabPanel
        header={chartType}
        disabled={this.state.detailsTabDisabled}
        style={{ width: "25%" }}
      >
        <div
          className="ui-g dashboard"
          style={
            this.state.editLoaded === false ? { pointerEvents: "none" } : {}
          }
        >
          <div className="ui-g-12 card">
            <BPMStatistics
              displayType={displayType}
              chartType={chartType}
              chartData={chartData}
              chartOptions={chartOptions}
            ></BPMStatistics>
            <BPMStatistics
              displayType={DisplayType.TABLE}
              tableData={ChartHelper.renderProductLeadTimeDataPivot()}
            />
          </div>
        </div>
      </pr.TabPanel>
    );
  };

  getChart = (displayType, chartType, chartData, chartOptions) => {
    return (
      <pr.TabPanel
        header={chartType}
        disabled={this.state.detailsTabDisabled}
        style={{ width: "25%" }}
      >
        <div
          className="ui-g dashboard"
          style={
            this.state.editLoaded === false ? { pointerEvents: "none" } : {}
          }
        >
          <div className="ui-g-12 card">
            <BPMStatistics
              displayType={displayType}
              chartType={chartType}
              chartData={chartData}
              chartOptions={chartOptions}
              //   rootProps={{ "data-testid": "1" }}
              //   chartWrapperParams={{ view: { columns: [0, 2] } }}
              //   chartPackages={["corechart", "controls"]}
              //   controls={[
              //     {
              //       controlEvents: [
              //         {
              //           eventName: "statechange",
              //           callback: ({ chartWrapper, controlWrapper }) => {
              //             alert(
              //               "State changed to " +
              //                 JSON.stringify(controlWrapper.getState())
              //             );
              //           }
              //         }
              //       ],
              //       controlType: "CategoryFilter",
              //       options: {
              //         filterColumnIndex: 1,
              //         ui: {
              //           labelStacking: "vertical",
              //           label: "Gender Selection:",
              //           allowTyping: false,
              //           allowMultiple: false
              //         }
              //       }
              //     }
              //   ]}
            />
          </div>
        </div>
      </pr.TabPanel>
    );
  };

  // #endregion
}



// WEBPACK FOOTER //
// ./src/components/Statistics/Chartsv2.js